/* ═══ صفحة المنتج: الشريط اللاصق يظهر بعد ما يخلص قسم المنتج ═══
   كان ظاهر من أول لحظة وبيغطّي جزء من الشاشة. دلوقتي بيطلع بس لما المستخدم
   يعدّي الصورة والمعلومات — يعني بقى تذكير وقت الحاجة له مش عنصر ثابت.
   ملاحظة: عمود المعلومات عنده position:sticky فبيفضل بالشاشة، عشان كده
   المرجع هو قسم المنتج كله مش العمود. */
(function () {
  'use strict';

  var HIDDEN = 'hc-sticky-hidden';

  function start() {
    var bar = document.querySelector('.sticky_cart');
    var anchor =
      document.querySelector('.product--small, .product--medium, .product--large') ||
      document.querySelector('.product__media-wrapper');
    if (!bar || !anchor) return;

    bar.classList.add(HIDDEN);

    var shown = null;
    var ticking = false;

    function check() {
      ticking = false;
      var passed = anchor.getBoundingClientRect().bottom < 120;
      if (passed === shown) return;
      shown = passed;
      if (passed) bar.classList.remove(HIDDEN);
      else bar.classList.add(HIDDEN);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* شبكة أمان: بعض التخطيطات ما بتبعتش scroll للـwindow زي ما نتوقع */
    setInterval(check, 500);
    check();

    window.__hcPdpCheck = check; // للتشخيص
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
